import React,{useEffect,useState} from 'react';
import {createPortal} from 'react-dom';
import {WHOT_EMOTE_BY_ID} from '../../config/whotEmotes';

const MAX_DISPLAY_MS=5000;
const OVERLAY_Z_INDEX=1000;
const VIEWPORT_MARGIN=8;

export default function WhotEmoteFloat({event,anchorRef}){
  const [visible,setVisible]=useState(false);
  const [position,setPosition]=useState(null);

  useEffect(()=>{
    if(!event?.timestamp||!event?.emoteId)return;
    setVisible(true);
    const t=window.setTimeout(()=>setVisible(false),MAX_DISPLAY_MS);
    return()=>window.clearTimeout(t);
  },[event?.timestamp,event?.emoteId]);

  useEffect(()=>{
    if(!visible||!event||!anchorRef?.current)return;
    const updatePosition=()=>{
      const rect=anchorRef.current?.getBoundingClientRect();
      if(!rect)return;
      setPosition({
        left:Math.min(Math.max(rect.left+rect.width/2,VIEWPORT_MARGIN),window.innerWidth-VIEWPORT_MARGIN),
        top:Math.max(rect.top+6,VIEWPORT_MARGIN),
      });
    };
    updatePosition();
    window.addEventListener('resize',updatePosition);
    window.addEventListener('scroll',updatePosition,true);
    return()=>{
      window.removeEventListener('resize',updatePosition);
      window.removeEventListener('scroll',updatePosition,true);
    };
  },[visible,event,anchorRef]);

  if(!visible||!event||!position||typeof document==='undefined')return null;
  const e=WHOT_EMOTE_BY_ID[event.emoteId];
  if(!e)return null;

  return createPortal(
    <div aria-live="polite" style={{
      position:'fixed',left:position.left,top:position.top,
      transform:'translate(-50%,0)',pointerEvents:'none',
      zIndex:OVERLAY_Z_INDEX,textAlign:'center',
      animation:'whotEmotePop 5s ease-out forwards',
    }}>
      <div style={{fontSize:58,lineHeight:1}}>{e.emoji}</div>
      <div style={{
        marginTop:3,padding:'4px 9px',borderRadius:9,
        background:'rgba(17,17,17,.94)',
        border:'1px solid rgba(251,191,36,.65)',
        color:'#fff',fontSize:11,fontWeight:900,whiteSpace:'nowrap',
      }}>{e.text}</div>
      <style>{'@keyframes whotEmotePop{0%{opacity:0;transform:translate(-50%,-80px) scale(.65)}12%{opacity:1;transform:translate(-50%,0) scale(1.05)}72%{opacity:1;transform:translate(-50%,70px) scale(1)}100%{opacity:0;transform:translate(-50%,120px) scale(.94)}}'}</style>
    </div>,
    document.body
  );
}
